module.exports = __webpack_public_path__ + "img/rajesh_d.33ec1c0c.png";